// const domain = "http://192.168.0.205:2943"
const domain = "https://api.icmn.cn"




import axios from 'axios'

function request(url, data, method) {
    var token = ''
    if (sessionStorage.getItem('token')) {
        token = sessionStorage.getItem('token')
    }
    if (method) {
        return new Promise((resolve) => {
            axios({
                url: domain + url,
                headers: {
                    'content-Type': 'application/json',
                    "Authorization": 'Bearer ' + token
                },
                params: data,
                method: method || 'POST'
            }).then(res => {
                return resolve(res.data)
            })

        })
    } else {
        return new Promise((resolve) => {
            axios({
                url: domain + url,
                headers: {
                    'content-Type': 'application/json',
                    "Authorization": 'Bearer ' + token
                },
                data,
                method: method || 'POST'
            }).then(res => {
                return resolve(res.data)
            })

        })
    }
}
export {
    request,
    domain
};